import { render, staticRenderFns } from "./activity_rule.vue?vue&type=template&id=c9b828f8&scoped=true"
import script from "./activity_rule.vue?vue&type=script&lang=js"
export * from "./activity_rule.vue?vue&type=script&lang=js"
import style0 from "./activity_rule.vue?vue&type=style&index=0&id=c9b828f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b828f8",
  null
  
)

export default component.exports